import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9624ca84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BigPlaceholder P-Rel" }
const _hoisted_2 = { class: "BigContainer" }
const _hoisted_3 = {
  key: 0,
  class: "BigLoading"
}
const _hoisted_4 = {
  key: 0,
  class: "P-Abs D-Flex D-Flex F-Bold F_85em Shadow1 BGBlur Rad2 BG1 P1em",
  style: {"z-index":"100","inset-inline-start":"0.7em","top":"0.7em","gap":"0.5em"}
}
const _hoisted_5 = {
  class: "M-Auto D-Flex",
  style: {"gap":"0.2em"}
}
const _hoisted_6 = { class: "V-Auto" }
const _hoisted_7 = { class: "O-75 V-Auto" }
const _hoisted_8 = {
  class: "M-Auto D-Flex H-100",
  style: {"gap":"0.2em"}
}
const _hoisted_9 = { class: "V-Auto" }
const _hoisted_10 = { class: "O-75 V-Auto" }
const _hoisted_11 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_12 = {
  class: "M-Auto D-Flex H-100",
  style: {"gap":"0.2em"}
}
const _hoisted_13 = { class: "V-Auto" }
const _hoisted_14 = { class: "O-75 V-Auto" }
const _hoisted_15 = {
  class: "BG1 Shadow2 BGBlur",
  style: {"box-shadow":"var(--shadow2)","border-radius":"0 0 var(--rad1) var(--rad1)"}
}
const _hoisted_16 = {
  class: "M-Auto F-Bold P_5em color3 CatalogName",
  style: {"font-size":"1.65em"}
}
const _hoisted_17 = {
  key: 0,
  style: {"padding":"0.5em 2em"}
}
const _hoisted_18 = {
  class: "W-100 D-Flex FlexWrap",
  style: {"gap":"0.5em","justify-content":"flex-end","align-items":"center"}
}
const _hoisted_19 = { class: "F-Bold" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesColSplitter" }, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "P1em"
}
const _hoisted_22 = {
  key: 0,
  class: "H-Auto F2em color4 O-25"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "W-100",
  style: {"height":"6em"}
}, null, -1))
const _hoisted_24 = {
  key: 2,
  class: "P1em"
}
const _hoisted_25 = {
  class: "W-100 D-Flex FlexWrap H-Auto CardsHolder",
  style: {"justify-content":"center","gap":"1em"}
}
const _hoisted_26 = { class: "M-Auto" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { style: {"padding":"0.6em 0.3em","overflow":"hidden","align-self":"center"} }
const _hoisted_29 = {
  style: {"white-space":"nowrap"},
  class: "P1_25em"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "W-100",
  style: {"height":"6em"}
}, null, -1))
const _hoisted_31 = {
  key: 2,
  class: "D-Flex F-Bold F1_25em H-100 color2 O-50"
}
const _hoisted_32 = { class: "M-Auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesLoading = _resolveComponent("CookiesLoading")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesCatalogItemCard = _resolveComponent("CookiesCatalogItemCard")!
  const _component_WhatsappBuuble = _resolveComponent("WhatsappBuuble")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.Loading.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createVNode(_component_CookiesLoading)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["BigBody", _ctx.FillBodyHeight])
        }, [
          (_ctx.CatalogAvailable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/Catalogs/ViewAllCatalogs'))),
                  class: "Pointer",
                  style: {"text-align":"center"}
                }, [
                  _createElementVNode("span", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, [
                      _createVNode(_component_CookiesIcon, {
                        class: "SQR1_5em",
                        style: {"padding-bottom":"0.2em"},
                        ID: ('Main' as IconsIDs)
                      }, null, 8, ["ID"])
                    ]),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.Translate('All Catalogs')), 1)
                  ])
                ]),
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.SelectCat(undefined))),
                  class: "Pointer",
                  style: {"text-align":"center"}
                }, [
                  _createElementVNode("span", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_CookiesIcon, {
                        class: "SQR1em O-50",
                        style: {"padding-bottom":"0.2em","transform":"rotate(-90deg)"},
                        ID: ('SortingArrow' as IconsIDs)
                      }, null, 8, ["ID"])
                    ]),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.CookiesData.Name), 1)
                  ])
                ]),
                (_ctx.CurrentCat)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, [
                          _createVNode(_component_CookiesIcon, {
                            class: "SQR1em O-50",
                            style: {"padding-bottom":"0.2em","transform":"rotate(-90deg)","user-select":"none"},
                            ID: ('SortingArrow' as IconsIDs)
                          }, null, 8, ["ID"])
                        ]),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.CurrentCat), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.CatalogAvailable)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", {
                  class: "CatalogImage D-Flex P-Rel Rad1",
                  style: _normalizeStyle('background-image: url(' + _ctx.DefaultImageHandler(_ctx.CookiesData.ImgUrl) + ')')
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.CookiesData.Name), 1)
                  ])
                ], 4),
                (_ctx.CurrentCat)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        (_ctx.SelectedCatalogItems.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_CookiesIcon, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.OnlySelected = !_ctx.OnlySelected)),
                                ToolTip: _ctx.Translate('Show Selected Items'),
                                class: "SQR2em F1_25em Pointer",
                                ID: ('Show' as IconsIDs),
                                style: _normalizeStyle(_ctx.OnlySelected ? 'filter: drop-shadow(0 0 0.2em '+ _ctx.Theme.UserColors.second +')' : ''),
                                Color: ({ ColorA: _ctx.OnlySelected ? _ctx.Theme.UserColors.third : _ctx.Theme.Shade1 } as IconColor)
                              }, null, 8, ["ToolTip", "ID", "style", "Color"]),
                              _createElementVNode("div", {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.OnlySelected = !_ctx.OnlySelected)),
                                class: "V-Auto F1_5em Pointer"
                              }, [
                                _createElementVNode("span", _hoisted_19, "(" + _toDisplayString(_ctx.SelectedCatalogItems.length) + ")", 1),
                                _createElementVNode("span", null, _toDisplayString(_ctx.Translate(' items selected ')), 1)
                              ]),
                              _hoisted_20
                            ], 64))
                          : _createCommentVNode("", true),
                        _createVNode(_component_CookiesIcon, {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => ([_ctx.ViewType = 'Tiles', _ctx.LocalSave('CookiesCatalogViewType_' + _ctx.$route.params.CatalogID, 'Tiles')])),
                          ToolTip: _ctx.Translate('Tiles View'),
                          class: "SQR2_5em Pointer",
                          ID: ('TileView' as IconsIDs)
                        }, null, 8, ["ToolTip", "ID"]),
                        _createVNode(_component_CookiesIcon, {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => ([_ctx.ViewType = 'GRID', _ctx.LocalSave('CookiesCatalogViewType_' + _ctx.$route.params.CatalogID, 'GRID')])),
                          ToolTip: _ctx.Translate('Grid View'),
                          class: "SQR2_5em Pointer",
                          ID: ('GridView' as IconsIDs)
                        }, null, 8, ["ToolTip", "ID"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.CurrentCat)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", {
                        class: "W-100 D-Flex FlexWrap H-Auto CardsHolder",
                        style: _normalizeStyle([{"justify-content":"center"}, [_ctx.ViewType === 'GRID' ? 'gap: 3.5em 1em;' : '', _ctx.ViewType === 'Tiles' ? 'gap: 1em;' : '']])
                      }, [
                        (_ctx.FilteredItems.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.Translate('No Data')), 1))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FilteredItems, (item) => {
                          return (_openBlock(), _createBlock(_component_CookiesCatalogItemCard, {
                            key: item.ID,
                            onOpenImage: ($event: any) => (_ctx.OpenImage(item)),
                            onSelected: _ctx.CatalogItemSelected,
                            ViewType: _ctx.ViewType,
                            onDeSelected: _ctx.CatalogItemDeSelected,
                            Selected: _ctx.IsItemSelected(item.ID),
                            CatalogItemData: item
                          }, null, 8, ["onOpenImage", "onSelected", "ViewType", "onDeSelected", "Selected", "CatalogItemData"]))
                        }), 128))
                      ], 4),
                      _hoisted_23
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.CurrentCat)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.SelectCat('All'))),
                          style: {"user-select":"none","width":"10em","padding":"1em 1.5em"},
                          class: "Pointer HoverUp F1_25em F-Bold BG1 Shadow1 BGBlur Rad2 color2 D-Flex"
                        }, [
                          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.Translate('All')), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Categories, (category) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: category,
                            onClick: ($event: any) => (_ctx.SelectCat(category)),
                            style: {"user-select":"none","width":"18em","flex-direction":"column","overflow":"hidden"},
                            class: "Pointer HoverUp F1_25em F-Bold BG1 Shadow1 BGBlur Rad2 color2 D-Flex"
                          }, [
                            _createElementVNode("div", {
                              class: "W-100",
                              style: _normalizeStyle([{"height":"10em","background-position":"center","background-size":"cover"}, 'background-image: url(' + _ctx.DefaultImageHandler(_ctx.$store.state.CookiesConfig.CategoriesImages ? _ctx.$store.state.CookiesConfig.CategoriesImages[category]: '') + ')'])
                            }, null, 4),
                            _createElementVNode("span", _hoisted_28, [
                              _createElementVNode("span", _hoisted_29, _toDisplayString(category), 1)
                            ])
                          ], 8, _hoisted_27))
                        }), 128))
                      ]),
                      _hoisted_30
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (!_ctx.CatalogAvailable && _ctx.Loading.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.ErrorText), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createVNode(_component_WhatsappBuuble)
  ], 64))
}